import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme, _, classes) => {
    return {
        icon: {
            width: '80%',
            height: 'auto',
        },
        item: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            cursor: 'pointer',
            width: 40,
            height: 48,
            padding: `${theme.spacing(0.25)} ${theme.spacing(0.5)} 0 ${theme.spacing(0.5)}`,
            '&:hover': {
                backgroundColor: theme.palette.primary[1000],
            },
            [`&.${classes.activeLink}:hover`]: {
                background: theme.palette.primary[800],
            },
        },
        iconLarge: {
            width: '100%',
        },
        iconMedium: {
            width: '75%',
        },
        iconSmall: {
            width: '60%',
        },
        activeLink: {
            backgroundColor: theme.palette.primary[800],
        },
        logoContainer: {
            width: 48,
            height: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 0 4px 0',
            '&:hover': {
                backgroundColor: theme.palette.primary[1000],
            },
            [`&.${classes.activeLink}:hover`]: {
                backgroundColor: theme.palette.primary[800],
            },
        },
        logo: {
            width: 34,
        },
        logoLink: {
            width: 34,
            height: '34px !important',
            display: 'block',
        },
    }
})

export default useStyles
